export const Header = ({ firstName }: { firstName: string }) => (
  <div className="mb-4">
    <p className="text-xl font-bold mb-2 pb-1">
      Help {firstName} download the OneStep app.
    </p>
    <div>You can invite your patient to download and enter the app in 1 of 3 methods:</div>
  </div>
);
